import React, { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import useDebounce from '../../../../hooks/useDebounce';
import { UserFilters } from '../../../../interfaces/interfaces';
import NumberInput from '../../../Shared/MinMaxInputs/NumberInput/NumberInput';
import numeral from 'numeral';

import * as AppState from '../../../../AppState';

const HoaFee = () => {

	const [hoaMax, setHoaMax] = useState('-1');
	const [gsFilters, setGsFilters] = useRecoilState(AppState.gsFilters);

	useDebounce(() => {
		const hoaMaxNumber = hoaMax === '' ? -1 : parseInt(hoaMax.replace(/,/g, ''));
		setGsFilters((currVal: UserFilters) => ({ ...currVal, maxHoaFee: hoaMaxNumber }));
	}, 1000, [hoaMax]);

	const globalHoaMax = gsFilters.maxHoaFee;

	useEffect(() => {
		const formattedHoaMax = numeral(globalHoaMax.toString()).format();
		setHoaMax(formattedHoaMax);
	}, [globalHoaMax]);

	return <div className='cc-min-max-inputs w-100'>
		<NumberInput
			id='maxHoaFeeFilter'
			value={hoaMax === '-1' ? '' : hoaMax}
			placeholder='No Max'
			label='Max HOA Fee (per month)'
			onChange={setHoaMax}
			className='form-control'
			currency
		/>
	</div>;
};

export default HoaFee;